import { initialState } from './index';
import { RootState } from '../../../types';

// const selectSlice = (state: RootState) => state.loadingSteps || initialState;

export const getLoadingSteps = (state: RootState) =>
  state.loadingSteps || initialState;
